import { observer } from 'mobx-react'
import React from 'react'

import UserProfileController from '../../controllers/UserProfileController/UserProfileController'

const UserProfileRoute = (): React.ReactElement => <UserProfileController />

export default observer(UserProfileRoute)
